/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "Auth": {
        "identityPoolId": "us-east-1:eafb213c-7b93-4a76-956f-e588f4bde753",
        "region": "us-east-1",
        "userPoolId": "us-east-1_e934fyDh6",
        "userPoolWebClientId": "2j1q69p1gd5mk75aape1ck8arg",
        "mandatorySignIn": true
    }
};


export default awsmobile;